<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>Email Templates</h1>
        <p class="subtitle">
          Edit the HTML source of each transactional email. Changes save to the
          database and apply immediately — no redeploy needed.
        </p>
      </div>
    </header>

    @if (loading()) {
      <div class="loading-message">Loading templates...</div>
    } @else if (error()) {
      <div class="empty-state">{{ error() }}</div>
    } @else {
      <div class="tpl-layout">
        <!-- List -->
        <aside class="tpl-list panel">
          <div class="tpl-list-title">Templates</div>
          @for (t of templates(); track t.name) {
            <button
              type="button"
              class="tpl-item"
              [class.active]="t.name === selectedName()"
              (click)="select(t.name)"
              title="{{ t.name }}"
            >
              <span class="tpl-item-name">{{ t.name }}</span>
              @if (t.overridden) {
                <span class="badge badge-custom">edited</span>
              }
            </button>
          }
        </aside>

        <!-- Editor + preview -->
        @if (selectedName(); as name) {
          <div class="tpl-workspace">
            <div class="tpl-toolbar panel">
              <div class="tpl-toolbar-title">
                {{ name }}
                @if (selectedMeta()?.overridden) {
                  <span class="badge badge-custom">edited</span>
                } @else {
                  <span class="badge badge-default">default</span>
                }
              </div>
              <div class="tpl-toolbar-actions">
                @if (savedMessage()) {
                  <span class="status-ok">{{ savedMessage() }}</span>
                }
                @if (saveError()) {
                  <span class="status-err">{{ saveError() }}</span>
                }
                @if (dirty()) {
                  <span class="status-unsaved">unsaved changes</span>
                }
                <button
                  type="button"
                  class="btn btn-ghost"
                  (click)="reset()"
                  [disabled]="saving() || !selectedMeta()?.overridden"
                >
                  Reset to default
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="save()"
                  [disabled]="saving() || !dirty()"
                >
                  {{ saving() ? "Saving…" : dirty() ? "Save changes" : "Saved" }}
                </button>
              </div>
            </div>

            <div class="tpl-panes">
              <div class="tpl-editor-pane panel">
                <div class="pane-label">Source (MJML/HTML)</div>
                @if (loadingSource()) {
                  <div class="loading-message">Loading source...</div>
                } @else {
                  <textarea
                    class="source-editor"
                    [value]="source()"
                    (input)="onEdit(editor.value)"
                    #editor
                    spellcheck="false"
                  ></textarea>
                }
              </div>
              <div class="tpl-preview-pane panel">
              <div class="pane-label">
                Preview
                @if (previewing()) {
                  <span class="previewing">rendering…</span>
                }
              </div>
              @if (previewError()) {
                <div class="preview-error">{{ previewError() }}</div>
              } @else if (previewHtml(); as safe) {
                <iframe
                  class="preview-frame"
                  [srcdoc]="safe"
                  sandbox=""
                  title="Email preview"
                ></iframe>
              } @else {
                <div class="preview-empty">Select a template to preview.</div>
              }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>
